export default "__VITE_ASSET__72557869__"